import { buildQuery } from '../../../utils/buildQuery';
import api from '../../../utils/api';

export interface ApplicantFilterParams {
  PageNumber?: number;
  PageSize?: number;
  ApplicationType?: number;
  ProgramId?: number;
  ProgramCode?: string;
  ProgramTypeId?: number;
  ModeOfStudyId?: number;
  ApplicationBatchId?: number;
  SessionId?: number;
  Name?: string;
  CreatedFrom?: string;
  CreatedTo?: string;
  ApplicationNumber?: string;
  Email?: string;
  ApplicantId?: string;
}

export interface Applicant {
  applicantId: string;
  applicationNumber?: string;
  name?: string;
  email?: string;
  isAdmin?: boolean;
  [key: string]: any;
}

export interface ApplicantListResponse {
  items: Applicant[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

interface ApplicantFilterRawResponse {
  message?: string;
  data?: {
    data?: Applicant[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    [key: string]: any;
  };
}

export interface AdminResetUserPasswordPayload {
  password: string;
  confirmPassword: string;
  email: string;
  applicantId: string;
  isAdmin: boolean;
}

export const getApplicantsFilter = async (params: ApplicantFilterParams) => {
  const url = buildQuery(params);
  const response = await api.get(`/Authorization/GetApplicantsFilter${url}`);
  const raw = response?.data as ApplicantFilterRawResponse;
  const items = raw?.data?.data ?? [];

  return {
    items,
    totalCount: raw?.data?.totalCount ?? items.length,
    pageNumber: raw?.data?.pageNumber ?? params.PageNumber ?? 1,
    pageSize: raw?.data?.pageSize ?? params.PageSize ?? 10,
  } as ApplicantListResponse;
};

export const adminResetUserPassword = async (payload: AdminResetUserPasswordPayload) => {
  return (await api.post(`/Authorization/AdminResetUserPassword`, payload))?.data;
};